<template>
  <div class="card">
    <template v-if="currentStep === 0">
      <div class="card__top">
        <div class="card-info">
          <div class="card-info__left">
            <div class="card-info__top" v-if="$store.state.main.options.disableHeader !== true">
              <Text705 v-if="$store.state.main.product.id === 705" />
              <div v-else>
                <div class="card-info__title"
                  :class="{ 'card-info__title--no-logo': !($store.state.main.options.logoImage) }"
                  v-if="['AddCard'].includes($route.name)">
                  <div>{{ $t(`app.title.${ $store.state.main.product.kind }`) }}</div>
                </div>

                <div class="card-info__name" v-if="$store.state.main.product.title">
                  <CustomTitle :product-id="$store.state.main.product.id" :value="$store.state.main.product.title" />
                  <Subtitle :product-id="$store.state.main.product.id" :value="$store.state.main.product.title" />
                </div>
              </div>
            </div>
            <div class="card-info-select">
              <PixieEditor class="card-info-select__pixie" @image-uploaded="imageUploaded" :show-button="false"
                ref="pixie" />
              <div class="card-select-image">
                <div class="card-select-image__single" v-if="(slickImages && slickImages.length === 1 &&
                  !$store.state.main.options.allowCustomImage) ||
                  !!$store.state.main.options.imageSelect
                ">
                  <div class="card-select-image__discount" v-if="$store.state.main.product.properties &&
                    $store.state.main.product.properties.face_multiplier &&
                    $store.state.main.product.properties.face_multiplier < 1
                  ">
                    <img src="../assets/svg/discount.svg" alt="">
                    <div class="card-select-image__discount-text">
                      <div>{{ $t('form.discount') }}</div>
                      <div class="card-select-image__discount-text-value">{{ ((1 -
                          $store.state.main.product.properties.face_multiplier) * 100).toFixed()
                      }}%</div>
                    </div>
                  </div>
                  <div class="card-select-image__image">
                    <img :src="$store.getters['card/current'].cardImage" alt="">
                  </div>
                </div>

                <div v-else>

                  <div class="card-select-image-multiple">

                    <div class="card-info-select__arrows">
                      <button type="button" class="card-info-select__arrow card-info-select__arrow--prev">
                        <IconArrow style="transform: rotate(180deg)" />
                      </button>
                      <button type="button" class="card-info-select__arrow card-info-select__arrow--next">
                        <IconArrow />
                      </button>
                    </div>

                    <div class="card-select-image-multiple__container">
                      <div class="card-select-image__discount" v-if="$store.state.main.product.properties &&
                        $store.state.main.product.properties.face_multiplier &&
                        $store.state.main.product.properties.face_multiplier < 1
                      ">
                        <img src="../assets/svg/discount.svg" alt="">
                        <div class="card-select-image__discount-text">
                          <div>{{ $t('form.discount') }}</div>
                          <div class="card-select-image__discount-text-value">{{ ((1 -
                              $store.state.main.product.properties.face_multiplier) * 100).toFixed()
                          }}%</div>
                        </div>
                      </div>
                      <slick ref="slick" :options="slickOptions" @afterChange="handleAfterChange">
                        <div class="card-select-image-multiple__item" v-for="(image, index) in slickImages"
                          :key="index">
                          <div class="card-select-image__image">
                            <img :src="image" alt="">
                          </div>
                        </div>
                        <div class="card-select-image-multiple__item card-select-image-multiple__item--custom-image"
                          v-if="$store.state.main.options.allowCustomImage">
                          <div class="card-select-image__custom-image">
                            <div class="card-select-image__custom-image-container event__action--custom-image"
                              @click="selectFile">
                              <div class="card-select-image__custom-image-gift">
                                <div class="card-select-image__custom-text">
                                  <span v-html="$t(`form.choose_the_design.${ $store.state.main.product.kind }`)"></span>
                                </div>
                                <div class="card-select-image__image-icon">
                                  <IconUploadImage />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </slick>
                    </div>
                  </div>
                  <div class="card__block-header card__block-header--main"
                    v-if="$store.state.main.options.allowCustomImage">
                    <template>
                      {{ $t(`form.choose_the_design_short`)
                      }}
                      <span class="no-wrap">
                        {{ $t('form.or') }}
                        <default-btn is-link @click="clickOnUploadMyImage()">
                          {{ $t('form.create_yours') }}
                        </default-btn>
                      </span>
                    </template>
                  </div>
                  <div class="card__block-header card__block-header--main" v-html="$t('form.choose_the_design_short')"
                    v-else></div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-info__activation-info">
            <ActivationInfo v-if="parseInt($store.state.main.product.properties.activation_delay) !== 0"
              :delay="parseInt($store.state.main.product.properties.activation_delay) || 0" />
          </div>

          <div class="card-info__right">
            <template v-if="hasFaces">
              <div class="card-info__block-container">
                <div class="card-info__block">
                  <div class="card-info__block-header" v-if="hasMultipleFaces">
                    {{ $t('form.choose_face') }}
                  </div>
                  <div class="card-info__block-header" v-else>{{ $t('form.face') }}</div>
                  <div class="card-info__block-content">
                    <face-selector @set-description="setDescription"></face-selector>
                  </div>
                </div>

                <div class="card-info__block">
                  <div class="card-info__block-header card-info__block-header--center">
                    {{ $t('form.enter_quantity') }}
                    <div class="widget-tooltip" v-if="$store.getters['cart/quantity'] >= $store.state.main.maxCartCount">
                      <div class="widget-tooltip__icon">
                        <IconWarning />
                      </div>
                      <div class="widget-tooltip__content" tabindex="-1" v-if="!isPayVisible">
                        <div class="widget-tooltip__content-text">
                          <span v-html="$t('cart.full_cart')"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-info__block-content">
                    <quantity-selector></quantity-selector>
                  </div>
                </div>
              </div>
              <div class="card-info__block-notation" v-if="commissionValue">
                <IconWarning/> <span>{{ $t('form.to_pay') }} — {{ commissionValue }} ({{ $t('form.commission') }} {{ commissionPercent }}%)</span>
              </div>
            </template>
            <div class="card-info__block-container" v-else>
              <div class="card-info__block-content">
                <span class="card-info__warning">{{ $t(`form.gift_cards_unavailable.${ $store.state.main.product.kind }`) }}</span>
              </div>
            </div>

            <div class="card-info__activation" v-if="extendedTitle">
              <div class="card-info__activation-icon"><IconBell /></div>
              <div class="card-info__activation-text">{{ extendedTitle }}</div>
            </div>

            <div class="widget-form-step__btns">
              <default-btn class="widget-btn widget-btn--no-icon widget-btn--full-width widget-btn--next"
                @click="nextStep()" small>
                <span>{{ $t('form.buttons.next') }}</span>
              </default-btn>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="currentStep === 1">
      <recipient-mobile-es v-if="!['ru', 'kz', 'by'].includes(product.region)" ref="recipient" @pay-my-self="addToCartAndPay()"
        @fire-prev-step="prevStep()"></recipient-mobile-es>
      <recipient-mobile v-else ref="recipient" @pay-my-self="addToCartAndPay()" @fire-prev-step="prevStep()">
      </recipient-mobile>
    </template >


    <template>
      <div class="card__bottom">
        <div class="card__block card__block--actions" v-if="$store.getters['card/current'].type !== 'test'">
          <div class="card__buttons card__buttons--actions"
            v-if="$store.getters['card/current'].id === null && !this.isFirstProduct">
            <default-btn white big :class="{ 'button--grey': !hasFaces }"
              class="widget-action--add-another-certificate-cancel" v-if="!this.isFirstProduct" :disabled="!hasFaces"
              @click.prevent="backToCart()">
              <span>{{ $t('form.buttons.cancel') }}</span>
            </default-btn>
          </div>
          <div class="card__buttons card__buttons--actions" v-if="$store.getters['card/current'].id !== null">
            <default-btn @click.prevent="saveToCart()" class="widget-action--save-edit">
              <span>{{ $t('form.buttons.save_changes') }}</span>
            </default-btn>
            <default-btn white big @click.prevent="backToCart()" class="widget-action--cancel-edit">
              <span>{{ $t('form.buttons.cancel') }}</span>
            </default-btn>
          </div>
        </div>

        <div class="card__block card__block--center" v-if="$store.getters['card/current'].type === 'test'">
          <div class="message message--success" v-html="$t('form.test_was_sent')" v-if="isShipped"></div>
          <div class="message message--error" v-if="error" v-html="error"></div>
          <button class="button button--action button--shadow button--large event__action--send-test"
            @click="sendTestCertificate" :disabled="isPending">
            <span v-if="!isPending">{{ $t('form.buttons.send') }}</span>
            <span v-if="isPending" v-html="$t('form.test_is_sending')"></span>
          </button>
        </div>

      </div>
    </template>


  </div>
</template>

<script>
import FaceSelector from '../components/FaceSelector'
import QuantitySelector from '../components/QuantitySelector'
import RecipientMobile from '../components/RecipientMobile'
import RecipientMobileEs from '../components/RecipientMobileEs'
import Slick from 'vue-slick'
import PixieEditor from '../components/PixieEditor'

import { removeEmoji, numberFormat } from 'app/modules/utils'

import 'slick-carousel/slick/slick.css'
import DefaultBtn from '../components/default/DefaultBtn'
import ActivationInfo from './ActivationInfo'
import IconArrow from './icons/IconArrow'
import IconUploadImage from './icons/IconUploadImage'
import IconWarning from './icons/IconWarning'
import IconBell from './icons/IconBell'

import Text705 from './custom/Text705'

import { scrollIntoView } from 'seamless-scroll-polyfill'
import Subtitle from 'app/versions/6/components/custom/Subtitle.vue'
import CustomTitle from 'app/versions/6/components/custom/CustomTitle.vue'

export default {
  components: {
    CustomTitle,
    Subtitle,
    IconUploadImage,
    ActivationInfo,
    DefaultBtn,
    IconArrow,
    IconWarning,
    IconBell,
    'face-selector': FaceSelector,
    'quantity-selector': QuantitySelector,
    'recipient-mobile': RecipientMobile,
    'recipient-mobile-es': RecipientMobileEs,
    PixieEditor,
    Slick,
    Text705
  },
  data() {
    return {
      currentStep: 0,
      editId: null,
      slickOptions: {
        dots: true,
        prevArrow: '.card-info-select__arrow--prev',
        nextArrow: '.card-info-select__arrow--next',
        slidesToShow: 1,
        adaptiveHeight: true
      },
      slickImages: [],
      extendedTitle: '',
      regexp: /st.giftery.ru/
    }
  },
  computed: {
    product: function () {
      if (typeof this.$store.state.main.product === 'undefined') {
        return {}
      } else {
        return this.$store.state.main.product
      }
    },
    isValid() {
      // return !!(this.model.title && this.model.text)
      return true
    },
    hasFaces() {
      return this.$store.state.main.faces && this.$store.state.main.faces.length !== 0
    },
    hasMultipleFaces() {
      return this.$store.state.main.faces && this.$store.state.main.faces.length > 1
    },
    isFirstProduct() {
      if (typeof this.$store.state.cart !== 'undefined') {
        return this.$store.state.cart.positions.length < 1
      } else {
        return true
      }
    },
    commissionValue() {
      const multiplier =
        this.product &&
        this.product.properties &&
        this.product.properties.face_multiplier

      if (multiplier && multiplier > 1) {
        return numberFormat(this.$store.state.card.current.face * multiplier, 0, ',', ' ') + ' ' + this.$store.state.region.currency
      }

      return 0
    },
    commissionPercent() {
      const multiplier =
        this.product &&
        this.product.properties &&
        this.product.properties.face_multiplier

      if (multiplier && multiplier > 1) {
        return (Math.abs(multiplier - 1) * 100).toFixed()
      }

      return 0
    },

  },
  watch: {
    '$store.state.main.product.images': {
      handler(val) {
        const uploadedImages = this.$store.state.card.uploadedImages[this.product.id]
        this.slickImages = uploadedImages && uploadedImages.length > 0 ? [...val, ...uploadedImages] : [...val]
        if (this.$refs.slick) this.reInit()
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.dispatch('main/setPreload', false)

    this.$nextTick(() => {
      this.sendYandexEcommerceDetail()
    })
  },
  methods: {
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep -= 1
      }
    },
    nextStep() {
      this.currentStep += 1
    },
    next() {
      this.$refs.slick.next()
    },
    prev() {
      this.$refs.slick.prev()
    },
    clickOnUploadMyImage() {
      if (this.$refs.slick.currentSlide() === this.slickImages.length) {
        this.selectFile()
      } else {
        this.$refs.slick.goTo(this.slickImages.length)
      }
    },
    reInit() {
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
      })
    },
    handleAfterChange(event, slick, currentSlide) {
      let image = this.slickImages[currentSlide]

      if (!image) {
        image = this.slickImages[0]
      }

      this.$store.dispatch('card/setCardImage', image)
    },
    backToCart() {
      this.$router.push({ name: 'Cart' })
    },
    saveToCart() {
      if (this.validate()) {
        this.addPosition()
        this.$router.push({ name: 'Cart' })
      }
    },
    addToCart() {
      if (this.validate()) {
        this.addPosition()
      }
    },
    addToCartAndPay() {
      if (this.validate()) {
        this.sendMainYandexGoal()
        this.addPosition()
        this.sendYandexEcommerceAdd()
        if (this.$store.state.main.options.code === 'askona') {
          this.sendAskonaAdd()
        }
        if (window.yaCounter33711084) {
          if (this.product.id === 17364) {
            window.ym(33711084, 'reachGoal', 'to_basket')
          }
        }
        this.$router.push({ name: 'Cart' })
      } else {
        this.$nextTick(() => {
          const firstError = document.querySelector('.field__error-message')

          if (firstError) {
            scrollIntoView(firstError, {
              block: 'center',
              behavior: 'smooth',
              inline: 'center'
            })
          }
        })
      }
    },
    sendMainYandexGoal() {
      if (!window.yaCounter84418648) {
        return
      }

      const goal = this.$store.state.card.current.type === 'friend' ? 'giftcard_podarok' : 'giftcardorder'
      window.ym(84418648, 'reachGoal', goal)
    },
    addPosition() {
      if (this.$store.state.card.current.type === 'myself') {
        this.$store.dispatch('card/setGreeting', null)
        this.$store.dispatch('card/setSenderName', null)
        this.$store.dispatch('card/setRecipientName', null)
        this.$store.dispatch('card/setSenderEmail', null)
        this.$store.dispatch('card/setSenderPhone', null)
      }

      if (this.$store.state.card.current.sendExactTime === false) {
        this.$store.dispatch('card/setSendTime', null)
      }

      this.$store.commit('card/setGreeting', removeEmoji(this.$store.state.card.current.greeting))
      this.$store.dispatch('cart/addPosition', this.$store.state.card.current)
    },
    validate() {
      this.$refs.recipient.$v.$touch()

      if (this.$refs.recipient.$refs.sendTime) {
        this.$refs.recipient.$refs.sendTime.$v.$touch()

        return !this.$refs.recipient.$v.$invalid && !this.$refs.recipient.$refs.sendTime.$v.$invalid
      } else {
        return !this.$refs.recipient.$v.$invalid
      }
    },
    selectFile() {
      this.$refs.pixie.$refs.file.click()
    },
    imageUploaded(img) {
      this.slickImages.push(img)
      this.reInit()
      this.$nextTick(() => {
        if (this.slickImages.length > this.slickOptions.slidesToShow) this.$refs.slick.goTo(this.slickImages.length - 1)
      })
      this.$store.dispatch('card/setCardImage', img)
      this.$store.dispatch('card/setUploadedImages', { productId: this.product.id, img })
    },
    sendYandexEcommerceAdd() {
      // Giftery Data Layer for E-commerce
      const currentCart = this.$store.state.card.current
      const title = this.product.title ? this.product.title : ''

      if (window.dataLayer) {
        window.dataLayer.push({
          ecommerce: {
            currencyCode: this.$store.state.region.currencyCode,
            add: {
              products: [
                {
                  id: currentCart.productId,
                  name: title,
                  price: currentCart.face,
                  category: 'Виджет',
                  quantity: currentCart.quantity,
                  variant: currentCart.type === 'friend' ? 'Отправить в подарок' : 'Отправить себе'
                }
              ]
            },
          }
        })
      }
    },
    sendAskonaAdd() {
      try {
        const currentCart = this.$store.state.card.current
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "event": "add",
          "ecommerce": {
            "currencyCode": "RUB",
            "add": {
              "products": [{
                "id": currentCart.productId + '_' + currentCart.face,
                "name" : "Подарочный сертификат",
                "price": currentCart.face,
                "discount": 0,
                "brand": "Askona",
                "category": "Сертификаты",
                "coupon": "Добавление в корзину - сертификат",
                "variant" : currentCart.face + " р",
                "list": "/landing/gift_certificates/",
                "position": 0,
                "quantity": currentCart.quantity
              }]
            }
          }
        });
        window.ym(1383371, 'reachGoal', 'addTocart', {"item": "certificate", "page_path": "/landing/gift_certificates/"});
      } catch (e) {
        console.error(e)
      }
    },
    sendYandexEcommerceDetail() {
      // Giftery Data Layer for E-commerce
      if (window.dataLayer) {
        window.dataLayer.push({
          ecommerce: {
            currencyCode: this.$store.state.region.currencyCode,
            detail: {
              products: [
                {
                  id: this.product.productId,
                  name: this.product.title,
                  category: 'Виджет',
                }
              ]
            },
          }
        })
      }
    },
    setDescription(data) {
      this.extendedTitle = data
    }
  },
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  &__top {
    background-color: transparent;
    box-sizing: border-box;
    padding: 0;
    margin-bottom: rem(30);

    @include mobile {
      margin-bottom: 0;
    }
  }

  &__block {
    height: 100%;

    &--actions {
      height: auto;
      padding: rem(30) 0 0;

      @include mobile {
        padding: 0;
      }
    }
  }

  &__block-header {
    font-size: rem(13);
    line-height: 120%;
    color: #6E7882;
    text-align: center;
    margin-top: rem(10);
  }

  &__block-header::v-deep {
    .btn--link {
      font-size: rem(13);
    }
  }

  &__custom-image-gift {
    width: rem(300);
    height: rem(137);
    background-color: #F7F8F9;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: rem(1) solid #F1F2F3;
    cursor: pointer;
  }

  &__separator {
    height: rem(2);
    background-color: #0E1E0E;
    margin: rem(30) 0;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    .btn {
      width: 100%;
      margin-bottom: rem(10);

      &:last-child {
        margin-bottom: 0;
      }
    }

    &--actions {
      padding: rem(30) 0 0;

      @include mobile {
        padding-top: rem(20);
      }
    }
  }
}

.card-info {
  display: flex;

  @include mobile {
    flex-direction: column;
  }

  &__left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__right {
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: rem(10);
    padding: rem(40) rem(10);
  }

  &__top {
    margin-bottom: rem(20);
  }

  &__title {
    font-size: rem(12);
    line-height: 120%;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: rem(8);
  }

  &__name {
    font-weight: 600;
    font-size: rem(15);
    line-height: 120%;
    color: #0E1E0E;
    text-align: center;

    &-sub {
      font-size: rem(13);
      line-height: rem(18);
      color: var(--theme-secondary-background-component);
    }
  }

  &__separator {
    width: rem(1);
    height: rem(40);
    flex-shrink: 0;
    background-color: #6E7882;
    opacity: 0.2;
    margin: 0 rem(25);
  }

  &__block {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:first-child {
      margin-right: rem(80);

      @include mobile {
        margin-right: 0;
      }
    }

    &:last-child {
      .card-info__block-header {
        text-align: center;
      }
    }

    &-notation {
      display: flex;
      align-items: center;
      margin-top: rem(15);

      span {
        &::first-letter {
          text-transform: uppercase;
        }
        font-size: rem(12);
        color: #6E7882;
      }
      svg {
        margin-right: rem(13);
      }
    }

  }

  &__block-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__block-header {
    font-size: rem(13);
    line-height: rem(16);
    color: #6E7882;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    margin-bottom: rem(10);

    &--center {
      justify-content: center;
    }
  }

  &__block-content {
    height: rem(36);
    display: flex;
    align-items: center;
  }

  &__warning {
    font-size: rem(15);
    color: #fa6400;
  }

  &__activation {
    display: flex;
    align-items: center;
    font-size: rem(12);
    line-height: 120%;
    padding-top: rem(12);
    margin-bottom: rem(-5);

    &-icon {
      display: flex;
    }

    &-text {
      padding-left: rem(12);
    }
  }
}

.card-select-image-multiple {
  position: relative;

  &__container {
    position: relative;
  }

  &__item {
    min-width: rem(300);
    max-width: rem(300);
    width: 100%;
  }
}

.card-info-select {
  min-width: rem(300);
  max-width: rem(300);
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: rem(10);
  margin-bottom: rem(20);

  &__pixie {
    width: 0;
    flex-grow: 0;
    flex-shrink: 0;
  }

  &__arrows {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: rem(-15);
    right: rem(-15);
    top: 0;
    bottom: rem(18);
    z-index: 1;
    pointer-events: none;

    @include mobile {
      display: none;
    }
  }

  &__arrow {
    width: rem(30);
    height: rem(30);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    pointer-events: auto;
    transition: 0.3s;
    box-shadow: 0 rem(6) rem(16) rgba(110, 120, 130, 0.12);

    &:hover {
      transition: 0.3s;
    }

    &::v-deep {
      svg {
        opacity: 0.6;
      }

      &:hover {
        svg {
          opacity: 1;
        }
      }
    }
  }
}

.card-select-image {
  position: relative;

  @include mobile {
    width: 100%;
  }

  &__discount {
    width: rem(63);
    height: rem(58);
    position: absolute;
    top: rem(-28);
    right: rem(5);
    z-index: 1;

    img {
      width: 100%;
    }

    &-text {
      width: 100%;
      height: 100%;
      font-weight: 700;
      font-style: italic;
      font-size: rem(10);
      line-height: 140%;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;

      &-value {
        font-size: rem(15);
      }
    }
  }

  img {
    max-width: 100%;
    border-radius: rem(10);
  }

  &__single {
    width: rem(300);
    max-height: rem(137);
    border-radius: rem(10);
    filter: drop-shadow(0px 6px 16px rgba(110, 120, 130, 0.12));
    margin: 0 auto;
  }


  &__image {
    max-width: rem(300);
    width: rem(300);
    height: rem(137);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: rem(10);
    margin: 0 auto;
  }

  &__custom {
    &-text {
      font-weight: 600;
      font-size: rem(12);
      color: var(--theme-primary-text-color-component);
      margin-top: rem(20);
      margin-bottom: rem(10);
    }
  }

  &__custom-image-gift {
    max-width: rem(300);
    width: rem(300);
    height: rem(137);
    background: var(--theme-primary-background-component);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: rem(10);
    cursor: pointer;
    margin: 0 auto;

    .card-select-image__image {
      background-size: auto;
    }
  }
}

.card-select-image::v-deep {
  .slick-list {
    overflow: hidden;
    border-radius: rem(10);
    filter: drop-shadow(0px 6px 16px rgba(110, 120, 130, 0.12));

    @include mobile {
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
  }

  .slick-dots {
    list-style-type: none;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: rem(10) 0 0;

    li {
      width: rem(6);
      height: rem(6);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: rem(6);

      &:last-child {
        margin-right: 0;
      }
    }

    button {
      width: rem(6);
      height: rem(6);
      background-color: #E9EBEC;
      font-size: 0;
      border-radius: 50%;
      padding: 0;
      border: none;
      appearance: none;
      cursor: pointer;
      transition: 0.3s;
    }

    .slick-active {
      width: rem(16);
      border-radius: rem(4);
      transition: 0.3s;

      button {
        width: rem(16);
        background: var(--theme-primary-background-component);
        border-radius: rem(4);
      }
    }
  }
}

.widget-tooltip {
  position: relative;
  appearance: none;
  margin-left: rem(6);
  margin-bottom: rem(2);

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__content {
    max-width: rem(133);
    min-width: rem(133);
    background: #ffffff;
    font-size: rem(13);
    font-weight: 400;
    line-height: 140%;
    color: #0B132A;
    text-align: left;
    position: absolute;
    left: rem(8);
    bottom: rem(35);
    opacity: 0;
    border-radius: rem(10);
    padding: rem(14) rem(20);
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1)) drop-shadow(10px 10px 10px rgba(110, 120, 130, 0.05)) drop-shadow(20px 10px 80px rgba(110, 120, 130, 0.1));
    transform: translate(-50%, 1rem);
    transition: all .2s ease-in-out;
    pointer-events: none;

    @include mobile {
      top: rem(-20);
      right: rem(-40);
      bottom: auto;
      left: auto;
    }

    &::before {
      content: '';
      position: absolute;
      top: 100%;
      right: rem(54);
      width: 0;
      height: 0;
      border: .5em solid transparent;
      border-top-color: #ffffff;
      transform: translate(-50%, 0);

      @include mobile {
        top: rem(24);
        right: rem(-19);
        border-top-color: transparent;
        border-left-color: #ffffff;
      }
    }
  }

  &:hover {
    cursor: help;

    .widget-tooltip__content {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
}

.link {
  background-color: transparent;
  color: #FA6400;
  text-decoration: underline;
  border: none;
  padding: 0;
  box-shadow: none;
  cursor: pointer;
}


.widget-form-step {
  display: grid;
  grid-template-columns: rem(300) auto;
  grid-gap: rem(30);

  &__btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: rem(20);

    &::v-deep {
      .btn {
        width: 100%;
      }
    }
  }
}
</style>
